define.alias("shared/components/shared/mavely/links/folder", "media/components/shared/mavely/links/folder");